import { AddNewMenu } from "./AddNewMenu";
export * from "./AddNewMenu";

export default AddNewMenu;
